import { Outlet, Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const VendorLayout = () => {
  const { currentUser, loading } = useAuth();

  // ⏳ Wait until auth is restored
  if (loading) {
    return <div>Loading...</div>;
  }

  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  if (currentUser.role !== 'vendor') {
    return <Navigate to="/unauthorized" replace />;
  }

  return <Outlet />;
};

export default VendorLayout;